'use strict';

require('./main_content');

const FOLLOW_FLYOUT_LOCALSTORAGE_KEY = 'merchant-page-clicked-follow-flyout';
const MIN_MODAL_WIDTH = 767;

function getSessionVariableKey(placeId) {
  return `mpp-follow-${placeId}`;
}

function removeFromStorage(placeId) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.removeItem(getSessionVariableKey(placeId))
    : undefined;
}

function getFromStorage(placeId) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.getItem(getSessionVariableKey(placeId))
    : undefined;
}

function setToStorage(placeId, value) {
  if (typeof sessionStorage !== 'undefined' && sessionStorage !== null) {
    return sessionStorage.setItem(getSessionVariableKey(placeId), value);
  }
  return null;
}

Groupon.FollowMerchant = class FollowMerchant {
  constructor(el, csrf, placeId, showNearbyPlaces, nearbyPlaceIds) {
    this.el = el;
    this.csrf = csrf;
    this.placeId = placeId;
    this.showNearbyPlaces = showNearbyPlaces;
    this.nearbyPlaceIds = nearbyPlaceIds;
    this.rootUrl = '/merchant-page';
    this.$container = $(this.el);
    this.$followButton = this.$container.find('.follow-text-container');
    this.$unfollowButton = this.$container.find('.unfollow-text-container');
    this.$countContainer = this.$container.find('.follow-count-container');
    this.$countSpan = this.$container.find('.follow-count-span');
    this.$flyoutContainer = this.$container.find('.follow-help-container');
    this.$gotItButton = this.$container.find('.got-it');
    this.followCounter = this.$container.data().followCount;
    this.isFollowing = this.$followButton.is(':hidden');
    this.hasMainFollowWidget =
      $('.mpp-container .follow-merchant-main-content').length > 0;
    this.updateFlyoutDisplay();
    this.bindEventHandlers();
    $(window).load(() => {
      //# if we have an automatic action pending
      const followAction = getFromStorage(this.placeId);
      removeFromStorage(this.placeId);

      switch (followAction) {
        case 'follow':
          this.followMerchant(false, true);
          break;

        case 'unfollow':
          this.unfollowMerchant(true);
          break;
      }
    });
  }

  updateFlyoutDisplay() {
    if (
      (typeof localStorage !== 'undefined' && localStorage !== null
        ? localStorage.getItem(FOLLOW_FLYOUT_LOCALSTORAGE_KEY)
        : undefined) === 'true' ||
      this.isFollowing
    ) {
      return this.$flyoutContainer.remove();
    } else {
      return this.$flyoutContainer.removeClass('hide');
    }
  }

  setFlyoutLocalStorage() {
    if (typeof localStorage !== 'undefined' && localStorage !== null) {
      localStorage.setItem(FOLLOW_FLYOUT_LOCALSTORAGE_KEY, 'true');
    }

    return this.updateFlyoutDisplay();
  }

  bindEventHandlers() {
    return $(document).ready(() => {
      this.$followButton.click(() => this.followMerchant());
      this.$countContainer.click(() => this.followMerchant());
      this.$unfollowButton.click(() => this.unfollowMerchant());
      this.$gotItButton.click(() => this.setFlyoutLocalStorage()); // listen to request a deal requests

      if (this.hasMainFollowWidget) {
        $('.follow-merchant-main-content').on('follow-requested', () => {
          return this.followMerchant(true);
        });
      }

      return $('.request-deal').on('deal-requested', () => {
        return this.switchToFollowing();
      });
    });
  }

  switchToFollowing() {
    this.isFollowing = true;
    this.$unfollowButton.removeClass('hide');
    this.$followButton.addClass('hide');
    this.$countContainer.addClass('hide');
    return this.setFlyoutLocalStorage();
  }

  switchToNotFollowing() {
    this.isFollowing = false;
    this.$followButton.removeClass('hide');
    this.$countContainer.removeClass('hide');
    return this.$unfollowButton.addClass('hide');
  }

  followMerchant(mainWidgetRequest = false, triggeredOnPageLoad = false) {
    if (this.isMakingAPIRequest) {
      return null;
    }

    this.isMakingAPIRequest = true;

    if (!mainWidgetRequest) {
      this.switchToFollowing();

      if (this.hasMainFollowWidget) {
        this.$container.trigger('follow-successful');
      }
    }

    const obj = {
      _csrf: this.csrf,
      placeId: this.placeId,
      triggeredOnPageLoad,
      nearbyPlaceIds:
        mainWidgetRequest &&
        this.showNearbyPlaces &&
        $(window).width() > MIN_MODAL_WIDTH
          ? this.nearbyPlaceIds
          : undefined,
    };
    return $.ajax({
      url: `${this.rootUrl}/follow-merchant`,
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(obj),
      success: res => {
        if (res.result !== 'ok') {
          this.switchToNotFollowing();
          this.$container.trigger('follow-unsuccessful');
        }

        if (MPP.JsonResponseHandler.loginRequired(res)) {
          return setToStorage(this.placeId, 'follow');
        }

        if (res.result !== 'ok') {
          return null;
        }

        if (mainWidgetRequest) {
          this.switchToFollowing();
          return this.$container.trigger('follow-successful', [res.data]);
        }
        return null;
      },
      error: () => {
        this.switchToNotFollowing();

        if (mainWidgetRequest) {
          return this.$container.trigger('follow-unsuccessful');
        }
        return null;
      },
      complete: () => {
        this.isMakingAPIRequest = false;
        return this.isMakingAPIRequest;
      },
    });
  }

  unfollowMerchant(triggeredOnPageLoad = false) {
    if (this.isMakingAPIRequest) {
      return null;
    }

    this.isMakingAPIRequest = true;
    this.switchToNotFollowing();

    if (this.hasMainFollowWidget) {
      this.$container.trigger('unfollow-successful');
      this.hasMainFollowWidget = false;
    }

    const obj = {
      _csrf: this.csrf,
      placeId: this.placeId,
      triggeredOnPageLoad,
    };
    return $.ajax({
      url: `${this.rootUrl}/follow-merchant/delete`,
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(obj),
      success: res => {
        if (res.result !== 'ok') {
          this.switchToFollowing();
          this.$container.trigger('follow-unsuccessful');
        }

        if (MPP.JsonResponseHandler.loginRequired(res)) {
          return setToStorage(this.placeId, 'unfollow');
        }

        if (res.result !== 'ok') {
          return this.switchToFollowing();
        }
        return null;
      },
      error: () => {
        return this.switchToFollowing();
      },
      complete: () => {
        this.isMakingAPIRequest = false;
        return this.isMakingAPIRequest;
      },
    });
  }
};
$(() => {
  const el = '.follow-merchant-righthand-module';

  if (!($(el).length > 0)) {
    return null;
  }

  const place = $('.mpp-container').data();
  const followConfig = $(el).data();
  const csrfToken = $('meta[name=csrf-token]').attr('content');
  new Groupon.FollowMerchant(
    el,
    csrfToken,
    place.placeId,
    followConfig.showNearbyPlaces,
    followConfig.nearbyPlaceIds
  );

  if (followConfig.displayFollowMainWidget) {
    return new Groupon.FollowMerchantMainContent(
      '.follow-merchant-main-content',
      csrfToken,
      followConfig.showNearbyPlaces
    );
  }
  return null;
});
